import { css } from "@emotion/react";

export const typographies = {
  // Neo
  NeoTitleM: css`
    font-size: 17px;
    line-height: 27px;
    font-weight: 400;
    font-family: "Neo Dunggeunmo Pro", sans-serif;
  `,
  NeoBodyL: css`
    font-size: 18px;
    line-height: 21px;
    font-weight: 400;
    font-family: "Neo Dunggeunmo Pro", sans-serif;
  `,
  NeoBodyM: css`
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    font-family: "Neo Dunggeunmo Pro", sans-serif;
  `,
  NeoBodyS: css`
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    font-family: "Neo Dunggeunmo Pro", sans-serif;
  `,
  NeoButtonL: css`
    font-size: 18px;
    line-height: 30px;
    font-weight: 400;
    font-family: "Neo Dunggeunmo Pro", sans-serif;
  `,
  NeoButtonS: css`
    font-size: 14px;
    line-height: 30px;
    font-weight: 400;
    font-family: "Neo Dunggeunmo Pro", sans-serif;
  `,
  NeoLabel: css`
    font-size: 14px;
    line-height: normal;
    font-weight: 400;
    font-family: "Neo Dunggeunmo Pro", sans-serif;
  `,

  // GoThic
  GoThicTitleS: css`
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    font-family: "Gothic A1", sans-serif;
  `,
  GoThicBodyS: css`
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    font-family: "Gothic A1", sans-serif;
  `,
  GoThicButtonM: css`
    font-size: 14px;
    line-height: 19.5px;
    font-weight: 400;
    font-family: "Gothic A1", sans-serif;
  `,
  GoThicLabelS: css`
    font-size: 12px;
    line-height: normal;
    font-weight: 500;
    font-family: "Gothic A1", sans-serif;
  `,

  // PF
  PFLabelL: css`
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
    font-family: "DOSGothic", sans-serif;
  `,
  PFLabelM: css`
    font-size: 14px;
    line-height: normal;
    font-weight: 400;
    font-family: "DOSGothic", sans-serif;
  `,
  PFLabelS: css`
    font-size: 12px;
    line-height: normal;
    font-weight: 400;
    font-family: "DOSGothic", sans-serif;
  `,

  // Pretendard
  PretendardRegular: css`
    font-size: 14px;
    line-height: 19.5px;
    font-weight: 400;
    font-family: "Pretendard", sans-serif;
  `,

  // Leferi
  LeferiBaseRegular: css`
    font-size: 20px;
    line-height: normal;
    font-weight: 700;
    font-family: "Leferi Base", sans-serif;
  `,
};
